jQuery(document).ready(function ($) {

  $('.alert .close').on('click', function (e) {
    e.preventDefault();
    $('.alerts').addClass('closed');
  });

  if ($('.btn-clear-tag').length > 0) {
    var tagText = $(".btn-clear-tag")[0].innerHTML;
    var regex = /inb/gi;
    if (tagText.indexOf("inb") > 0) {
      tagText = tagText.replace(regex, 'INB');
      $('.btn-clear-tag')[0].innerHTML = tagText;
    }
  }


  var tileCarousels = $('.cycle-slideshow[data-cycle-auto-init="false"]');
  tileCarousels.each(function (i) {
    var ScreenSize = '';
    var width = $(window).width();

    if (width < 768) {
      ScreenSize = 'sm';
    } else if (width >= 768 && width <= 1100) {
      ScreenSize = 'md';
    } else {
      ScreenSize = 'lg';
    }

    reinitCycle(tileCarousels[i]);

    $(window).resize(function () {
      //If passed breakpoint, re-init
      width = $(window).width();
      var NewScreenSize = '';

      if (width < 768) {
        NewScreenSize = 'sm';
      } else if (width >= 768 && width <= 1100) {
        NewScreenSize = 'md';
      } else {
        NewScreenSize = 'lg';
      }

      if (NewScreenSize !== ScreenSize) {
        ScreenSize = NewScreenSize;
        reinitCycle(tileCarousels[i]);
      }
    });
  });


  $('.news-items').cycle({
    swipe: true,
    slides: "> .news-item",
    carouselVisible: 1,
    carouselFluid: true,
    fx: "carousel",
    timeout: 0,
    next: "#news-cycle-next",
    prev: "#news-cycle-prev",
    allowWrap: false,
    autoHeight: "calc",
    cycleLog: false,
    centerHorz: true,
    pager: "#news-pager"
  });

  $('.gotoslide').on('keydown', function (e) {
    var slideNum = $(this).data('slidenum') - 1;
    if (e.which == 13) {
      $('.banner').cycle('goto', slideNum);
    }
  });

  $('.tile-slider .cycle-pager-next').on('keydown', function (e) {
    if (!($(this).hasClass('disabled'))) {
      if (e.which == 13) {
        $('.tile-slider .cycle-slideshow').cycle('next');
      }
    }
  });

  $('.tile-slider .cycle-pager-previous').on('keydown', function (e) {
    if (!($(this).hasClass('disabled'))) {
      if (e.which == 13) {
        $('.tile-slider .cycle-slideshow').cycle('prev');
      }
    }
  });

  // Functon to pull in Segmint promo banner
  function getBannerZoneId(zoneId) {
    return window.$egmint.getHtmlOffer(zoneId, function (response, error) {
      if (!error) {
        console.log('segmint no error');
        var div = document.createElement("div");
        div.innerHTML = response.content;
        document.getElementsByClassName("banner")[0].prepend(div.firstChild);
        console.log('banner init');
        waitForEl($('.promo-banner'), hpBannerInit, 10);
      } else {
        console.log(error);
      }
    });
  }

  enquire.register('screen and (max-width: 989px)', {
    match: function () {
      // Mobile Segmint banner
      var zoneId = 'en1zz5zXKRuERz';
      getBannerZoneId(zoneId);
    }
  }).register('screen and (min-width: 990px)', {
    match: function () {
      // Desktop Segmint banner
      var zoneId = 'en1Er9r67AuaXg';
      getBannerZoneId(zoneId);
    }
  });

});


function juicerCycle() {
  setTimeout(function () {
    if ($(window).width() < 768) {
      $('.j-stack').cycle({
        swipe: true,
        slides: "> .feed-item",
        timeout: 0,
        fx: 'fadeout',
        allowWrap: true,
        centerHorz: true,
        autoHeight: 'container',
        cycleLog: false,
        pager: "#social-pager"
      });
    }
  }, 1500);
}

function reinitCycle(tileCarousel) {
  var width = $(window).width();
  if (width < 768) {
    $('.tile-slider .cycle-slideshow').off();
    $(tileCarousel).cycle("destroy");
    $(tileCarousel).cycle({
      swipe: true,
      slides: "> .cycle-slide",
      carouselVisible: 1,
      carouselFluid: true,
      fx: "carousel",
      timeout: 0,
      carouselOffset: 0,
      next: "#cycle-next",
      prev: "#cycle-prev",
      centerHorz: true,
      cycleLog: false,
      allowWrap: false,
      pager: "#tile-slider-pager"
    });

    $('.tile-slider .cycle-slide-active').nextAll().addClass('cycle-off-canvas-right');
    $('.tile-slider .cycle-slideshow').on('cycle-next cycle-pager-activated', function () {
      $('.cycle-off-canvas-right').removeClass('cycle-off-canvas-right');
      $('.cycle-slide-active').nextAll().addClass('cycle-off-canvas-right');

      $('.cycle-off-canvas-left').removeClass('cycle-off-canvas-left');
      $('.cycle-slide-active').prevAll().addClass('cycle-off-canvas-left');
    });

    $('.tile-slider .cycle-slideshow').on('cycle-prev cycle-pager-activated', function () {
      $('.cycle-off-canvas-right').removeClass('cycle-off-canvas-right');
      $('.cycle-slide-active').nextAll().addClass('cycle-off-canvas-right');

      $('.cycle-off-canvas-left').removeClass('cycle-off-canvas-left');
      $('.cycle-slide-active').prevAll().addClass('cycle-off-canvas-left');
    });
  } else if (width >= 768 && width <= 1100) {
    $(tileCarousel).cycle("destroy");
    $('.tile-slider .cycle-slideshow').off();
    $(tileCarousel).cycle({
      swipe: false,
      slides: "> .cycle-slide",
      carouselVisible: 2,
      carouselFluid: true,
      fx: "carousel",
      timeout: 0,
      carouselOffset: 0,
      next: "#cycle-next",
      prev: "#cycle-prev",
      cycleLog: false,
      allowWrap: false,
      pager: "#tile-slider-pager"
    });
    $('.tile-slider .cycle-slide-active').next().nextAll().addClass('cycle-off-canvas-right');

    $('.tile-slider .cycle-slideshow').on('cycle-next cycle-pager-activated', function () {
      $('.cycle-off-canvas-right').removeClass('cycle-off-canvas-right');
      $('.cycle-slide-active').next().nextAll().addClass('cycle-off-canvas-right');

      $('.cycle-off-canvas-left').removeClass('cycle-off-canvas-left');
      $('.cycle-slide-active').prevAll().addClass('cycle-off-canvas-left');
    });

    $('.tile-slider .cycle-slideshow').on('cycle-prev cycle-pager-activated', function () {
      $('.cycle-off-canvas-right').removeClass('cycle-off-canvas-right');
      $('.cycle-slide-active').next().nextAll().addClass('cycle-off-canvas-right');

      $('.cycle-off-canvas-left').removeClass('cycle-off-canvas-left');
      $('.cycle-slide-active').prevAll().addClass('cycle-off-canvas-left');
    });
  } else {
    $(tileCarousel).cycle("destroy");
    $('.tile-slider .cycle-slideshow').off();
    $(tileCarousel).cycle({
      swipe: false,
      slides: "> .cycle-slide",
      carouselVisible: 3,
      carouselFluid: true,
      fx: "carousel",
      timeout: 0,
      carouselOffset: 0,
      next: "#cycle-next",
      prev: "#cycle-prev",
      cycleLog: false,
      allowWrap: false,
      pager: "#tile-slider-pager"
    });
    $('.tile-slider .cycle-slide-active').next().next().nextAll().addClass('cycle-off-canvas-right');

    $('.tile-slider .cycle-slideshow').on('cycle-next cycle-pager-activated', function () {
      $('.cycle-off-canvas-right').removeClass('cycle-off-canvas-right');
      $('.cycle-slide-active').next().next().nextAll().addClass('cycle-off-canvas-right');

      $('.cycle-off-canvas-left').removeClass('cycle-off-canvas-left');
      $('.cycle-slide-active').prevAll().addClass('cycle-off-canvas-left');
    });

    $('.tile-slider .cycle-slideshow').on('cycle-prev cycle-pager-activated', function () {
      $('.cycle-off-canvas-right').removeClass('cycle-off-canvas-right');
      $('.cycle-slide-active').next().next().nextAll().addClass('cycle-off-canvas-right');

      $('.cycle-off-canvas-left').removeClass('cycle-off-canvas-left');
      $('.cycle-slide-active').prevAll().addClass('cycle-off-canvas-left');
    });
  }
}

function hpBannerInit() {
  $('.banner .banner-content:first-child .parallax-image').on('load', function () {
    $('.banner').cycle({
      swipe: true,
      slides: "> div",
      fx: "fadeOut",
      timeout: 0,
      autoHeight: 'container',
      pager: '.slide-pager',
      cycleLog: false,
      pagerTemplate: '<span tabindex="0" class="gotoslide" data-slidenum="{{slideNum}}" aria-label="Go to Slide {{slideNum}}">•</span>'
    });

    var rellax = new Rellax('.parallax-image', []);
  });
}

function waitForEl(selector, callback, maxTimes) {
  if (jQuery(selector).length) {
    callback();
  } else {
    if (maxTimes > 0) {
      maxTimes--;
      setTimeout(function () {
        waitForEl(selector, callback, maxTimes);
      }, 100);
    }
  }
}